import { Button } from "@/ui-components/button-with-loading";

type LoadMoreButtonProps = {
  loading: boolean;
  loadNextPage: () => void;
};

export const LoadMoreButton = (props: LoadMoreButtonProps) => {
  return (
    <div className="flex justify-center py-2">
      <Button
        disabled={props.loading}
        onClick={props.loadNextPage}
        variant="secondary"
        loading={props.loading}
      >
        Load more stories
      </Button>
    </div>
  );
};
